import { playerEnteredFullscreenAction } from 'app-webtech-core/modules/player/actions/enteredFullscreen';
import { guidePlayChannelAtIndexThunkAction } from './playChannelAtIndex';
import { guidePropertiesSelector } from '../selectors/properties';
import { isValidChannelIndex } from '../helpers/isValidChannelIndex';
import { isChannel } from '../helpers/isChannel';
import { linearChannelsFetchBySlugSelector } from '../../linearChannels/selectors/fetchBySlug';

export const guidePlayCurrentOrDefaultIndexThunkAction = ({
  defaultFirstItemIndex = 1,
  defaultFirstItemSlug,
}) => async (dispatch, getState) => {
  dispatch(playerEnteredFullscreenAction());

  const state = getState();
  const { currentPlayingIndex, list } = guidePropertiesSelector(state);

  let startingIndex = currentPlayingIndex;
  if (!list.find(isValidChannelIndex(startingIndex))) {
    startingIndex = defaultFirstItemIndex;
  }

  if (defaultFirstItemSlug) {
    const channel = linearChannelsFetchBySlugSelector(state)(defaultFirstItemSlug);
    if (channel) {
      const slugIndex = list.findIndex((row) => isChannel(row) && row.id === channel._id);
      if (slugIndex > -1) {
        startingIndex = slugIndex;
      }
    }
  }

  // Fallback to the first channel if the index is not valid
  if (!list.find(isValidChannelIndex(startingIndex))) {
    startingIndex = list.findIndex((item) => isChannel(item));
  }

  await dispatch(
    guidePlayChannelAtIndexThunkAction({
      index: startingIndex,
      setSelected: true,
    }),
  );
};
